import styleInject from './../../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".BancontactForm-module_margin__sfppm {\n  margin-bottom: var(--pp-spacing-m);\n}\n\n.BancontactForm-module_dateContainer__KWqO6 {\n  display: flex;\n  align-items: center;\n  gap: var(--pp-spacing-l);\n}";
var styles = {"margin":"BancontactForm-module_margin__sfppm","dateContainer":"BancontactForm-module_dateContainer__KWqO6"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=BancontactForm.module.scss.js.map
